import { render } from "./FormOverviewPage.vue?vue&type=template&id=4b00dda1&ts=true"
import script from "./FormOverviewPage.vue?vue&type=script&lang=ts"
export * from "./FormOverviewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__